import { Icon, IconButton, ImageFallback, InputStepper, HStack } from '@genial/components';
import { BoxRadius, Color, ColorTypes, Spacing, Typography } from '@genial/design-tokens';
import { Utils } from '@genial/utils';
import React from 'react';

import {
  TableContentItemColumn,
  TableContentItemText,
} from '../../../../../../../components/TableContent';
import { messageError } from '../../../../../../../store/batchTicket/constants';
import {
  equityMaxLotSize,
  equityMaxPriceItem,
  equityMinLotSize,
  equityMinPriceItem,
} from '../../../../../utils';

import { AddedProductResponsiveItemEquityProps } from '.';

export const AddedProductItemEquityDesktop: React.FC<AddedProductResponsiveItemEquityProps> = ({
  data,
  hasPriceChangeTax,
  onChangePriceItem,
  onChangeQuantityItem,
  onRemoveProduct,
  priceChangeTaxIcon,
  priceChangeTaxIconColor,
  priceChangeTaxTextColor,
  priceItem,
  quantityItem,
  totalPrice,
  inputIsDisabled,
  totalPriceIsInvalid,
}) => {
  return (
    <HStack
      w={'full'}
      space={Spacing['inline.xxxs']}
      justifyContent="space-between"
      alignItems="center">
      <TableContentItemColumn direction="row" flex={3} space={Spacing['inline.nano']}>
        <ImageFallback
          src={data?.quote?.icons?.light || ''}
          alt="logo"
          width="54px"
          height="48px"
          testID="product-img"
          resizeMode="cover"
          borderRadius={BoxRadius.sm}
          resizeMethod="scale"
        />
        <TableContentItemColumn justifyContent="center">
          <TableContentItemText variant="semibold">
            {data?.quote?.productName || messageError}
          </TableContentItemText>
          <TableContentItemText>{data?.quote?.symbol || messageError}</TableContentItemText>
        </TableContentItemColumn>
      </TableContentItemColumn>
      <TableContentItemColumn space={Spacing['inline.quarck']}>
        <TableContentItemText color="neutral.dark">Último preço</TableContentItemText>
        <TableContentItemColumn
          space={Spacing['inline.quarck']}
          direction="row"
          alignItems="center">
          <TableContentItemText>
            {Utils.Mask.Money(data?.quote?.lastPrice || 0)}
          </TableContentItemText>
          {hasPriceChangeTax && (
            <Icon
              name={priceChangeTaxIcon}
              size="xxxxxs"
              color={Color[priceChangeTaxIconColor] as ColorTypes.Option}
              testID="last-price-arrow"
            />
          )}
          <TableContentItemText
            fontSize={Typography['fontsize.xs']}
            color={priceChangeTaxTextColor}>
            {Utils.Mask.Percentage(data?.quote?.priceChangeTax || 0)}
          </TableContentItemText>
        </TableContentItemColumn>
        <TableContentItemText color="neutral.medium" fontSize={Typography['fontsize.xs']}>
          Atualizado às {Utils.Mask.DateFormat(data?.quote?.tradeDate || new Date(), 'HH:mm')}
        </TableContentItemText>
      </TableContentItemColumn>
      <TableContentItemColumn flex={0.5} space={Spacing['inline.quarck']}>
        <TableContentItemText>M. compra</TableContentItemText>
        <TableContentItemText>{Utils.Mask.Money(data?.quote?.bidPrice || 0)}</TableContentItemText>
      </TableContentItemColumn>
      <TableContentItemColumn flex={0.5} space={Spacing['inline.quarck']}>
        <TableContentItemText>M. Venda</TableContentItemText>
        <TableContentItemText>{Utils.Mask.Money(data?.quote?.askPrice || 0)}</TableContentItemText>
      </TableContentItemColumn>
      <TableContentItemColumn flex={0.5} space={Spacing['inline.quarck']}>
        <TableContentItemText>Fech.</TableContentItemText>
        <TableContentItemText>
          {Utils.Mask.Money(data?.quote?.closePrice || 0)}
        </TableContentItemText>
      </TableContentItemColumn>
      <TableContentItemColumn flex={1} space={Spacing['inline.quarck']}>
        <TableContentItemText>Quantidade</TableContentItemText>
        <InputStepper
          disabled={inputIsDisabled}
          isDisabled={inputIsDisabled}
          stepperValue={data?.quote?.lotSize || equityMinLotSize}
          min={data?.quote?.lotSize || equityMinLotSize}
          max={equityMaxLotSize}
          name="equity-quantity-input"
          testId="equity-quantity-input"
          keyboardType="numeric"
          fontSize={Typography['fontsize.md']}
          defaultValue={quantityItem}
          onChange={onChangeQuantityItem}
          showErrorMessage={false}
        />
      </TableContentItemColumn>
      <TableContentItemColumn flex={1.5} space={Spacing['inline.quarck']}>
        <TableContentItemText>Preço por ativo</TableContentItemText>
        <InputStepper
          disabled={inputIsDisabled}
          isDisabled={inputIsDisabled}
          stepperValue={equityMinPriceItem}
          max={equityMaxPriceItem}
          min={equityMinPriceItem}
          name="equity-amount-price"
          testId="equity-amount-price"
          keyboardType="numeric"
          fontSize={Typography['fontsize.md']}
          ignoreStepperDivision
          maskOption="money"
          defaultValue={priceItem || equityMinPriceItem}
          onChange={onChangePriceItem}
          showErrorMessage={false}
        />
      </TableContentItemColumn>
      <TableContentItemColumn space={Spacing['inline.quarck']}>
        <TableContentItemText>Total estimado</TableContentItemText>
        <TableContentItemText>{Utils.Mask.Money(totalPrice || 0)}</TableContentItemText>
        {totalPriceIsInvalid && (
          <TableContentItemText fontSize={Typography['fontsize.xs']} color="feedback.error.default">
            Valor máximo atingido
          </TableContentItemText>
        )}
      </TableContentItemColumn>
      <IconButton
        testId="icon-button"
        borderRadius={BoxRadius.sm}
        onPress={onRemoveProduct}
        icon="Trash"
        p={0}
        iconColor={Color['feedback.error.default']}
        iconSize="xs"
      />
    </HStack>
  );
};
